import type { Moment } from 'moment'
import { useIntl } from 'react-intl'
import styled from 'styled-components'

import LineArrowRightIcon from 'LuxKit/Icons/line/LineArrowRightIcon'
import BodyText from 'LuxKit/Typography/BodyText'
import Group from 'components/utils/Group'
import {
  ISO_DATE_FORMAT,
  INTL_SHORT_DAY_NAME_DAY_MONTH,
  INTL_SHORT_DAY_NAME_DAY_MONTH_YEAR,
} from 'constants/dateFormats'
import { intlDateFormatter } from 'lib/datetime/dateUtils'

const TimeText = styled(BodyText)``

const Dates = styled.div`
  width: 100%;
`

interface Props {
  start?: Moment
  end?: Moment
}

function DatesPickedText({ start, end }: Props) {
  const intl = useIntl()
  if (!start && !end) {
    return null
  }

  if (!end && start) {
    return (
      <Dates>
        <TimeText
          variant="medium"
          weight="bold"
          forwardedAs="time"
          dateTime={start.format(ISO_DATE_FORMAT)}
        >
          {intlDateFormatter(start, INTL_SHORT_DAY_NAME_DAY_MONTH_YEAR, intl.locale)}
        </TimeText>
      </Dates>
    )
  }

  return (
    <Group
      direction="horizontal"
      verticalAlign="center"
      gap={8}
      wrap="wrap"
      fullWidth
    >
      <Group direction="horizontal" verticalAlign="center" gap={8}>
        <TimeText
          variant="medium"
          weight="bold"
          forwardedAs="time"
          dateTime={start!.format(ISO_DATE_FORMAT)}
        >
          {intlDateFormatter(
            start,
            start!.isSame(end, 'year') ?
              INTL_SHORT_DAY_NAME_DAY_MONTH :
              INTL_SHORT_DAY_NAME_DAY_MONTH_YEAR,
            intl.locale,
          )}
        </TimeText>
        <LineArrowRightIcon size="XS" />
        <TimeText
          variant="medium"
          weight="bold"
          forwardedAs="time"
          dateTime={end!.format(ISO_DATE_FORMAT)}
        >
          {intlDateFormatter(end, INTL_SHORT_DAY_NAME_DAY_MONTH_YEAR, intl.locale)}
        </TimeText>
      </Group>
      <BodyText as="span" variant="medium">
        {intl.formatMessage(
          {
            id: 'wp5S8C7FoRF6B6EkwzAm',
            defaultMessage: '({dayCount, plural, one {# day} other {# days}})',
            description: 'Duration in days for a trip date range in the trip planner feature',
          },
          { dayCount: end!.diff(start, 'days') + 1 },
        )}
      </BodyText>
    </Group>
  )
}

export default DatesPickedText
